//@ts-nocheck
import { useEffect, useState } from 'react'
import { graphqlFetch } from '@pylot-data/graphqlFetch'
import { STORE_LOCATER } from '../graphql/StoreLocater'
import { useRouter } from 'next/router'

export type StoreLocation = {
    address: string
    city: string
    country_id: string
}

export type StoreListResponse = {
    storeList: StoreLocation[]
    loading: boolean
    searchResultCount: number
    mapApi: string
    isStoreLocatorEnabled: boolean
    storeListMeta: StoreListMeta
}

export type StoreListMeta = {
    metaData: {
        meta_description?: string
        meta_keyword?: string
        page_title?: string
    }
}

export const useStoreList = (
    searchTerm = '',
    storeTypeFilter: number[] = []
): StoreListResponse => {
    const [storeList, setStoreList] = useState<StoreLocation[]>([])
    const [loading, setLoading] = useState(true)
    const [storeListMeta, setStoreListMeta] = useState<StoreListMeta>({
        metaData: {}
    })
    const [isStoreLocatorEnabled, setIsStoreLocatorEnabled] = useState(false)
    const [searchResultCount, setSearchResultCount] = useState(0)
    const [mapApi, setMapApi] = useState<string | undefined>(undefined)
    const { locale } = useRouter()
    const fetchStoreList = async () => {
        try {
            const result = await graphqlFetch<
                StoreListVariables,
                { storeLocator: { items: StoreLocation[] } }
            >({
                query: STORE_LOCATER,
                variables: {
                    searchTerm: `%${searchTerm}%`,
                    storeTypeFilter: storeTypeFilter
                },
                locale: `${locale} `
            })

            if (result.errors) {
                throw new Error(`Failed to fetch store list: ${result.errors}`)
            }

            const { data } = result
            const fetchedStoreList = data?.storeLocator.items ?? []
            const enabledStores = fetchedStoreList?.filter(
                (store) => store.is_active
            )
            setStoreListMeta({
                metaData: {
                    description: data?.storeLocator?.meta_description,
                    keyword: data?.storeLocator?.meta_keyword,
                    title: data?.storeLocator?.page_title
                }
            })
            setIsStoreLocatorEnabled(data?.storeLocator?.is_active)
            setStoreList(enabledStores)
            if (searchTerm) {
                setSearchResultCount(enabledStores?.length)
            }
            setMapApi(data?.storeLocator?.google_map_api)
        } catch (error) {
            console.error('Error fetching store list:', error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchStoreList()
    }, [searchTerm, storeTypeFilter])

    return {
        storeList,
        loading,
        searchResultCount,
        mapApi,
        isStoreLocatorEnabled,
        storeListMeta
    }
}
